import { AdvertiserCardInfo } from "./AdvertiserCardCell";
import { AdvertiserWithMetrics, AgencyAdvertiserMetricsSummary } from "../../../../types/advertiserMetricsTypes";
import { transformRowValue } from "../../../../helpers/campainRowFormatHelpers";

export type AdvertiserRowData = {
  id: string;
  name: string;
  domain: string;
  hubspotConnected: boolean;
  hubspotPortalId?: string;
  card: AdvertiserCardInfo;
  campaignCount: number;
  spendMtd: string;
  impressions: string;
  ctr: string;
  ctrTrend: "up" | "down" | "neutral";
};

const formatMetric = (value: number | string | null | undefined, type: "CURRENCY" | "PERCENTAGE" | "FLAT"): string =>
  String(transformRowValue(value ?? 0, false, true, type));

const formatDomain = (domain?: string | null): string => {
  const trimmed = domain?.trim();
  return trimmed || "—";
};

export const mapAdvertiserWithMetricsToRow = (
  advertiser: AdvertiserWithMetrics,
  details?: {
    domain?: string;
    hubspot_authed?: boolean;
    hubspot_portal_id?: string;
    advertiser_card_name?: string;
    paymentMethod?: { card?: { last4?: string; brand?: string } } | null;
  },
): AdvertiserRowData => ({
  id: advertiser.brandgenAdvertiserId,
  name: advertiser.name,
  domain: formatDomain(details?.domain),
  hubspotConnected: details?.hubspot_authed ?? false,
  hubspotPortalId: details?.hubspot_portal_id?.trim() || undefined,
  card: {
    hasCard: Boolean(details?.paymentMethod?.card?.last4),
    last4: details?.paymentMethod?.card?.last4,
    brand: details?.paymentMethod?.card?.brand,
    friendlyName: details?.advertiser_card_name?.trim() || undefined,
  },
  campaignCount: advertiser.campaignCount,
  spendMtd: formatMetric(advertiser.spendMtd, "CURRENCY"),
  impressions: formatMetric(advertiser.impressions, "FLAT"),
  ctr: formatMetric(advertiser.ctr, "PERCENTAGE"),
  ctrTrend: "neutral",
});

export const formatAgencyMetricsSummary = (summary: AgencyAdvertiserMetricsSummary) => ({
  activeCampaigns: summary.activeCampaigns,
  totalSpendMtd: formatMetric(summary.totalSpendMtd, "CURRENCY"),
  avgCtr: formatMetric(summary.avgCtr, "PERCENTAGE"),
});
